module.exports = __webpack_public_path__ + "media/images/icon_area-c1f0faeb538883491b75f9f127e293f1.png";